import { render, staticRenderFns } from "./UserStatusListDropdown.vue?vue&type=template&id=453ced3e&"
import script from "./UserStatusListDropdown.vue?vue&type=script&lang=js&"
export * from "./UserStatusListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports